import axios from "../../config/axios";
import {
  FETCH_CATTLEDETAIL_FAILURE,
  FETCH_CATTLEDETAIL_REQUEST,
  FETCH_CATTLEDETAIL_SUCCESS,
  GET_SEARCH_RESULT_SUCCESS,
  GET_SEARCH_RESULT_FAILURE,
  FETCH_REQUEST_CATTLEDETAIL_SUCCESS,
  FETCH_REQUEST_CATTLEDETAIL_FAILURE
} from "./types";

export const fetchCATTLEDetailRequest = () => {
  return {
    type: FETCH_CATTLEDETAIL_REQUEST,
  };
};
export const fetchCATTLEDetailSuccess = (model) => {
  return {
    type: FETCH_CATTLEDETAIL_SUCCESS,
    payload: model,
  };
};
export const fetchCATTLEDetailFailure = (error) => {
  return {
    type: FETCH_CATTLEDETAIL_FAILURE,
    payload: error,
  };
};
export const fetchRequestCATTLEDetailSuccess = (model) => {
  return {
    type: FETCH_REQUEST_CATTLEDETAIL_SUCCESS,
    payload: model,
  };
};
export const fetchRequestCATTLEDetailFailure = (error) => {
  return {
    type: FETCH_REQUEST_CATTLEDETAIL_FAILURE,
    payload: error,
  };
};

export const getSearchResultSuccess = (model) => {
  return {
    type: GET_SEARCH_RESULT_SUCCESS,
    payload: model,
  };
};
export const getSearchResultFailure = (error) => {
  return {
    type: GET_SEARCH_RESULT_FAILURE,
    payload: error,
  };
};

export const getCattleDetail = (currentPage, pagelimit) => async (dispatch) => {
  const created_by = JSON?.parse?.(localStorage?.getItem("superUser"))?.email
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`cattle/cattleInsuranceDetails/?page=${currentPage}&limit=${pagelimit}&created_by=${created_by}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchCATTLEDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchCATTLEDetailFailure(errorMsg));
    });
};

export const getSearchResult = (payLoad) => async (dispatch) => {
   const created_by = JSON?.parse?.(localStorage?.getItem("superUser"))?.email
  await axios
    .post(
      `cattle/cattleInsuranceDetails/?page=${payLoad.page}&limit=${payLoad.limit}&proposer_state=${payLoad.stateName}&proposer_email=${payLoad.emailId}&proposer_name=${payLoad.proposerName}&owner_name=${payLoad.ownerName}&policy_issuance_date=${payLoad.insuranceDate}&created_by=${created_by}`
    )
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(getSearchResultSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(getSearchResultFailure(errorMsg));
    });
};

export const getAssignedDoctorCattleDetail = (doctorPhone, currentPage, pagelimit) => async (dispatch) => {
  const created_by = JSON?.parse?.(localStorage?.getItem("superUser"))?.email
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`doctor/cattleCaseAssignedToDoctor/?doctor_phone=${doctorPhone}&page=${currentPage}&limit=${pagelimit}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchCATTLEDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchCATTLEDetailFailure(errorMsg));
    });
};

export const getAssignedInvestigatorCattleDetail = (investigatorPhone, currentPage, pagelimit) => async (dispatch) => {
  const created_by = JSON?.parse?.(localStorage?.getItem("superUser"))?.email
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`investigator/cattleCaseAssignedToInvestigator/?investigator_phone=${investigatorPhone}&page=${currentPage}&limit=${pagelimit}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchCATTLEDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchCATTLEDetailFailure(errorMsg));
    });
};
export const getAssignedSurveyorCattleDetail = (surveyor_phone, currentPage, pagelimit) => async (dispatch) => {
  const created_by = JSON?.parse?.(localStorage?.getItem("superUser"))?.email
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`surveyor/cattleCaseAssignedToSurveyor/?surveyor_phone=${surveyor_phone}&page=${currentPage}&limit=${pagelimit}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchCATTLEDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchCATTLEDetailFailure(errorMsg));
    });
};

export const getRequestDoctorCattleDetail = (doctorPhone, currentPage, pagelimit) => async (dispatch) => {
  const created_by = JSON?.parse?.(localStorage?.getItem("superUser"))?.email
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`doctor/requestListToDoctor/?doctor_phone=${doctorPhone}&page=${currentPage}&limit=${pagelimit}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchRequestCATTLEDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchRequestCATTLEDetailFailure(errorMsg));
    });
};

export const getRequestInvestigatorCattleDetail = (investigatorPhone, currentPage, pagelimit) => async (dispatch) => {
  const created_by = JSON?.parse?.(localStorage?.getItem("superUser"))?.email
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`investigator/requestListToInvestigator/?investigator_phone=${investigatorPhone}&page=${currentPage}&limit=${pagelimit}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchRequestCATTLEDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchRequestCATTLEDetailFailure(errorMsg));
    });
};

export const getRequestSurveyorCattleDetail = (surveyor_phone, currentPage, pagelimit) => async (dispatch) => {
  const created_by = JSON?.parse?.(localStorage?.getItem("superUser"))?.email
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`surveyor/requestListToSurveyor/?surveyor_phone=${surveyor_phone}&page=${currentPage}&limit=${pagelimit}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchRequestCATTLEDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchRequestCATTLEDetailFailure(errorMsg));
    });
};